import store from '@/store'
import { Action, config, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Vue } from "vue-property-decorator";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import Modelling from "@/store/modules/Modelling";
import Viewpoints from "@/store/modules/Viewpoints";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import { ViewpointFactorResource } from "@/api/model/ViewpointFactorResource";
import { ViewpointChoiceFactor } from "@/api/model/ViewpointChoiceFactor";
import Weighting from "@/store/modules/Weighting";
import Choices from "@/store/modules/Choices";
import _, { concat, includes, round } from 'lodash';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import WorkspaceOptionValues from '@/utils/WorkspaceOptionValues';
import { mapActions } from 'vuex';

config.rawError = true

const name = 'scoring';
if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}

@Module({dynamic: true, store, name: name, namespaced: true})
export default class Scoring extends VuexModule {

    viewpointScores: { [viewpointId: string]: ViewpointChoiceScore } = {};
    invalidatedViewpointScoring: { [viewpointId: string]: boolean } = {};


    @Mutation
    setViewpointChoiceScore(viewpointChoiceScore: ViewpointChoiceScore) {
        Vue.set(this.viewpointScores, viewpointChoiceScore.viewpointId, viewpointChoiceScore);
    }

    @Mutation
    setViewpointChoiceFactorScore(payload: { viewpointId: string, choiceId: string, factorResourceId: string, score: number }) {
        Vue.set(this.viewpointScores[payload.viewpointId].choiceScores[payload.choiceId].choiceFactorScores[payload.factorResourceId], 'score', payload.score);
    }


    @Mutation
    clear() {
        this.viewpointScores = {};
    }

    @Action
    async getScoresForViewpoints(payload: { decisionId: string, revision: string | number, viewpointIds: string[] }) {
        let scoringOutput = await VIEWPOINT_API.getScores(payload.decisionId, payload.revision, payload.viewpointIds);
        Object.keys(scoringOutput.viewpointScores).forEach(vId => this.setViewpointChoiceScore(scoringOutput.viewpointScores[vId]));
        return scoringOutput.viewpointScores;
    }


    @Action
    async getScoresForViewpoint(payload: { decisionId: string, revision: string | number, viewpointId: string }) {
        let multiPayload = {
            decisionId: payload.decisionId,
            revision: payload.revision,
            viewpointIds: [payload.viewpointId]
        }
        let scoreOutput = await this.getScoresForViewpoints(multiPayload)
        return scoreOutput[payload.viewpointId]
    }

    @Action
    async refreshScoring() {
        let modellingModule = getModule(Modelling)
        let viewpointIds = getModule(Viewpoints).selectedViewpointIds;
        
        if (!modellingModule.publishedDecisionModelDefinition || !viewpointIds || !viewpointIds.length) return;
        let input = {
            decisionId: modellingModule.publishedDecisionModelDefinition.modelId,
            revision: modellingModule.publishedDecisionModelDefinition.revision,
            viewpointIds: getModule(Viewpoints).selectedViewpointIds
        }
        console.log("VIEWPOINT ID IS:",viewpointIds)
        return await this.getScoresForViewpoints(input)
        
        
    }
    
    @Action
    async recalculateAllChoiceScores(viewpointId: string) {
        let choiceIds: string[] = getModule(Choices).choiceIds
        await Promise.all(choiceIds.map(cId => this.recalculateScores({
            viewpointId: viewpointId,
            choiceId: cId
        })));
    }
    @Action
    async getViewpointNames(payload:{viewpointIds: any[]}) {
        let viewpointmap = getModule(Viewpoints).decisionViewpointsMap 
        var viewpointNames = []
        for (let i = 0; i < payload.viewpointIds.length; i++) {
            var vpID = payload.viewpointIds[i]
            for(let vpm of Object.keys(viewpointmap)) {
                console.log("vpm", vpm )
                if(vpm === vpID) {
                    let name = viewpointmap[vpm].name
                    viewpointNames.push(name)
                }
            }
        }
        console.log("vp names returns", viewpointNames)
       
        return viewpointNames
    }


    // Begining of Radial and Donut Charts Data in Compare Viewpoints Tab:
    @Action
    async getRadialBarChartDataVPtab(payload: {scoreskeys: any, decisionId: string, viewpointIds: any[], factorIds?: any[], factorParentId: string, choiceId?: any}) {
        // ONLY 1 choice allowed. many viewpoints can be shown with bars being the viewpoint's factor score composition for the one choice
        let viewpointScores = this.viewpointScores
        let number_of_classes = 0
        let maximum_value = 1
        console.log("scores:",viewpointScores)
        let choices = getModule(Choices).choices
        let factors = getModule(Modelling).publishedModelFactorResources
        let viewpointmap = getModule(Viewpoints).decisionViewpointsMap 
        console.log("factor ids", payload.factorIds)
        console.log("parent id", payload.factorParentId)
        
        let final_dict = {};
        let series_dicts = []
        var viewpointNames = []
        var viewpointActiveIds = []
        for (let i = 0; i < payload.viewpointIds.length; i++) {
            var vpID = payload.viewpointIds[i]
            for(let vpm of Object.keys(viewpointmap)) {
                if(vpm === vpID) {
                    let name = viewpointmap[vpm].name
                    let vp_ID = viewpointmap[vpm].viewpointId
                    viewpointNames.push(name)
                    viewpointActiveIds.push(vp_ID)
                }
            }
        }
        console.log("THE ACTIVE viewpointNames",viewpointNames)
        console.log("THE ACTIVE viewpoint IDS",viewpointActiveIds)
        // get factor names into one dict of {FR1: "Name"}
        var factorNames = {};
        if((payload.factorIds != null) || (payload.factorIds.length != Object.keys(factors).length)) {
            for(var fId in payload.factorIds) {
                factorNames[payload.factorIds[fId]] = factors[payload.factorIds[fId]].name;
            }
        } else {
        var factorNames = await this.getFactorNames({factors:factors, keepIds: payload.factorIds});
        }        
        console.log("factorNames",factorNames)
        // get choice names into one dict of {choiceId: "Choice name"}
        var choiceNames = {};
        var sorted_ranked_choices = {};
        var selectedChoice = payload.choiceId
        if (payload.choiceId !== undefined) {
            Vue.set(choiceNames, selectedChoice, choices[selectedChoice].name)
            Vue.set(sorted_ranked_choices, selectedChoice, 1)
            }
        var other_factor_scores = []
        let raw_scores = []
        let class_baundries = []
        let name_of_classes = []
        let description_of_classes = []
        let all_scores = {}
        for(let vp of payload.viewpointIds) {
            let choiceScores = {}
            let factor_scores = [] 
            let scores_of_a_vp = []
            for(let factor of Object.keys(factorNames)) {
                let scoreSelectedIds = [] 
                for(let choice of  Object.keys(sorted_ranked_choices)) {
                    if(viewpointScores[vp].choiceScores[choice] != null) {
                        //scoreSelectedIds.push(payload.scoreskeys[vp][factor])
                        choiceScores = viewpointScores[vp].choiceScores[choice].choiceFactorScores
                        //console.log("mahsa",choiceScores[factor].id )
                       
                        scoreSelectedIds.push(payload.scoreskeys[vp][choiceScores[factor].id])
                        number_of_classes = payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"].length

                        for(let i = 0; i<number_of_classes; i++){
                        class_baundries.push(payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"][i].upperLimit)
                        name_of_classes.push(payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"][i].name)
                        description_of_classes.push(payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"][i].description)
                        }
                    }
                } 
                scores_of_a_vp.push(choiceScores[factor].score)
                
                
                let weight = choiceScores[factor].weight
                //factor_scores.push(score * weight)
                let factorName = factorNames[factor]
                //var series_dict = {'id': factor, 'name': factorName, 'data': factor_scores}
                var series_dict = {'id': factor, 'name': factorName, 'data': factor_scores}
                series_dicts.push(series_dict)
            }
            all_scores [vp] = [scores_of_a_vp]
                
        }
        description_of_classes = description_of_classes.slice(0,number_of_classes)
        name_of_classes = name_of_classes.slice(0,number_of_classes)
        class_baundries = class_baundries.slice(0,number_of_classes)
        description_of_classes = description_of_classes.reverse()
        name_of_classes = name_of_classes.reverse()
        class_baundries = class_baundries.reverse()
        class_baundries.unshift(-1)      
        console.log("Name of Classes",name_of_classes)
       
        //TODO: change it using payload.scoreskeys
        //console.log("inside score keys",payload.scoreskeys[:payload.viewpointIds])




        let scores_new = {}
        let num_of_factors = 0
        for (let v of Object.keys(all_scores)) {
            let new_factor_score = []
            num_of_factors = all_scores[v][0].length
            for(let i=0; i< num_of_factors; i++){
               for(let j=0; j<=number_of_classes;j++){
                    if (class_baundries[j]<all_scores[v][0][i] && all_scores[v][0][i]<=class_baundries[j+1]){
                        new_factor_score.push(j+1)
                    }
                }   
            }
            scores_new[v] = [new_factor_score]   
        }
        console.log("Name of Classes",scores_new)




        let raw_scores_new = []
        for (let i = 0; i < raw_scores.length; i++)
            {
                for(let j=0; j<=number_of_classes;j++){
                    if (class_baundries[j]<raw_scores[i] && raw_scores[i]<=class_baundries[j+1]){
                    raw_scores_new.push(j+1)
                    }
                    else{

                    }
                }   
            }
        let final_value  = {}
        let final_labels = []
        for(let v of Object.keys(scores_new)){
            let translated_score = []
            for (let i = 1; i <= number_of_classes; i++){
                translated_score.push(Math.round((scores_new[v][0].filter(x => x==i).length)*100/num_of_factors))
                final_labels.push(name_of_classes[i-1])     
         }
         final_value[v] = [translated_score]
        } 
        let num_of_vps = 0 
        final_labels = final_labels.slice(0, number_of_classes)

        num_of_vps = Object.keys(final_value).length
        let radial_data = {}
        let radial = {}
        for (let i = 0; i< num_of_vps; i++){
            radial = {
                data: {series:Object.values(final_value)[i][0]},
                title: {text: "ViewPoint Name: "+ viewpointNames[i]},
                labels: final_labels
            };
            radial_data[i] = radial
        }
        console.log("THE RADIAL", radial_data)
        return radial_data     
    }
    // End of Radial and Donut Charts Data .............................................





    // Beginning of Compare Viewpoints Summary Charts...............................................
    @Action
    async getSummaryChartDataVPtab(payload: {scoreskeys: any, decisionId: string, viewpointIds: any[], factorIds?: any[], factorParentId: string, choiceId?: any}) {
        // ONLY 1 choice allowed. many viewpoints can be shown with bars being the viewpoint's factor score composition for the one choice
        let viewpointScores = this.viewpointScores
        let number_of_classes = 0
        let maximum_value = 1
        console.log("scores:",viewpointScores)
        let choices = getModule(Choices).choices
        let factors = getModule(Modelling).publishedModelFactorResources
        let viewpointmap = getModule(Viewpoints).decisionViewpointsMap 
        console.log("factor ids", payload.factorIds)
        console.log("parent id", payload.factorParentId)
        
        let final_dict = {};
        let series_dicts = []
        var viewpointNames = []
        var viewpointActiveIds = []
        for (let vp_i = 0; vp_i < payload.viewpointIds.length; vp_i++) {
            var vpID = payload.viewpointIds[vp_i]
            for(let vpm of Object.keys(viewpointmap)) {
                if(vpm === vpID) {
                    let name = viewpointmap[vpm].name
                    let vp_ID = viewpointmap[vpm].viewpointId
                    viewpointNames.push(name)
                    viewpointActiveIds.push(vp_ID)
                }
            }
        }
        console.log("THE ACTIVE viewpointNames",viewpointNames)
        console.log("THE ACTIVE viewpoint IDS",viewpointActiveIds)
        // get factor names into one dict of {FR1: "Name"}
        var factorNames = {};
        if((payload.factorIds != null) || (payload.factorIds.length != Object.keys(factors).length)) {
            for(var fId in payload.factorIds) {
                factorNames[payload.factorIds[fId]] = factors[payload.factorIds[fId]].name;
            }
        } else {
        var factorNames = await this.getFactorNames({factors:factors, keepIds: payload.factorIds});
        }        
        console.log("factorNames",factorNames)
        // get choice names into one dict of {choiceId: "Choice name"}
        var choiceNames = {};
        var sorted_ranked_choices = {};
        var selectedChoice = payload.choiceId
        if (payload.choiceId !== undefined) {
            Vue.set(choiceNames, selectedChoice, choices[selectedChoice].name)
            Vue.set(sorted_ranked_choices, selectedChoice, 1)
            }
        var other_factor_scores = []
        let raw_scores = []
        let class_baundries = []
        let name_of_classes = []
        let description_of_classes = []
        let all_scores = {}
        let scores_of_all_vps = []
        for(let vp of payload.viewpointIds) {
            let choiceScores = {}
            let factor_scores = [] 
           
            for(let factor of Object.keys(factorNames)) {
                let scoreSelectedIds = [] 
                for(let choice of  Object.keys(sorted_ranked_choices)) {
                    if(viewpointScores[vp].choiceScores[choice] != null) {
                        //scoreSelectedIds.push(payload.scoreskeys[vp][factor])
                        choiceScores = viewpointScores[vp].choiceScores[choice].choiceFactorScores
                        //console.log("mahsa",choiceScores[factor].id )
                       
                        scoreSelectedIds.push(payload.scoreskeys[vp][choiceScores[factor].id])
                        number_of_classes = payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"].length

                        for(let i = 0; i<number_of_classes; i++){
                        class_baundries.push(payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"][i].upperLimit)
                        name_of_classes.push(payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"][i].name)
                        description_of_classes.push(payload.scoreskeys[vp][choiceScores[factor].id]["scoringKeys"][i].description)
                        }
                    }
                } 
                scores_of_all_vps.push(choiceScores[factor].score)
            }
                
        }
        description_of_classes = description_of_classes.slice(0,number_of_classes)
        name_of_classes = name_of_classes.slice(0,number_of_classes)
        class_baundries = class_baundries.slice(0,number_of_classes)
        description_of_classes = description_of_classes.reverse()
        name_of_classes = name_of_classes.reverse()
        class_baundries = class_baundries.reverse()
        class_baundries.unshift(-1)      
        console.log("Name of Classes",name_of_classes)
       
        let new_factor_score = []
        for(let i=0; i< scores_of_all_vps.length ; i++){
            for(let j=0; j<=number_of_classes;j++){
                if (class_baundries[j]<scores_of_all_vps[i] && scores_of_all_vps[i]<=class_baundries[j+1]){
                    new_factor_score.push(j+1)
                }
            }   
        }
        let final_value  = []
        let final_labels = []

        for (let i = 1; i <= number_of_classes; i++)
        {
            final_value.push(Math.round((new_factor_score.filter(x => x==i).length)*100/new_factor_score.length))
            final_labels.push(name_of_classes[i-1])
        }

        console.log("WHAT ARE THE NEW FACTOR SCORES>>>>>>>>>>>>>>>>>>>>>>>>>",final_value)
        console.log("WHAT ARE THE NEW FACTOR SCORES>>>>>>>>>>>>>>>>>>>>>>>>>",final_labels)
        let radial_data = {}
        radial_data = {
            data: {series:final_value},
            title: {text: 'All Selected Viewpoints Summary'},
            labels: final_labels
            };
        
        console.log("THE RADIAL", radial_data)
        return radial_data
    }

    // End of Compare Viewpoints Summary Charts.....................................................










    //............................................................................................................
    // Begining of BarCharts Data in Compare Viewpoints Tab:

    @Action
    async getStackedBarChartDataVPtab(payload: {decisionId: string, viewpointIds: any[], factorIds?: any[], factorParentId: string, choiceId?: any}) {
         // ONLY 1 choice allowed. many viewpoints can be shown with bars being the viewpoint's factor score composition for the one choice
        let viewpointScores = this.viewpointScores
       
        let maximum_value = 1
        console.log("scores:",viewpointScores)
        let choices = getModule(Choices).choices
        let factors = getModule(Modelling).publishedModelFactorResources
        let viewpointmap = getModule(Viewpoints).decisionViewpointsMap 
        
        let final_dict = {};
        let series_dicts = []
        var viewpointNames = []
        for (let i = 0; i < payload.viewpointIds.length; i++) {
            var vpID = payload.viewpointIds[i]
            for(let vpm of Object.keys(viewpointmap)) {
                if(vpm === vpID) {
                    let name = viewpointmap[vpm].name
                    viewpointNames.push(name)
                }
            }
        }
       
        // get factor names into one dict of {FR1: "Name"}
        var factorNames = {};
        if((payload.factorIds != null) || (payload.factorIds.length != Object.keys(factors).length)) {
            for(var fId in payload.factorIds) {
                factorNames[payload.factorIds[fId]] = factors[payload.factorIds[fId]].name;
            }
        } else {
        var factorNames = await this.getFactorNames({factors:factors, keepIds: payload.factorIds});
        }        
        console.log("factorNames",factorNames)
        // get choice names into one dict of {choiceId: "Choice name"}
        var choiceNames = {};
        var sorted_ranked_choices = {};
        var selectedChoice = payload.choiceId
        if (payload.choiceId !== undefined) {
            Vue.set(choiceNames, selectedChoice, choices[selectedChoice].name)
            Vue.set(sorted_ranked_choices, selectedChoice, 1)
            }
        var other_factor_scores = []
        for(let vp of payload.viewpointIds) {   
            for(let choice of  Object.keys(sorted_ranked_choices)) {
                if(viewpointScores[vp].choiceScores[choice] != null) {
                    let choiceScores = viewpointScores[vp].choiceScores[choice].choiceFactorScores
                    if(payload.factorParentId != 'M') {
                    let parentScore = choiceScores[payload.factorParentId].score * choiceScores[payload.factorParentId].weight
                    let totalChoiceScore = choiceScores['M'].score
                    other_factor_scores.push(totalChoiceScore - parentScore)
                    }
                }
            }
        }
       
        let raw_scores = []
        for(let factor of Object.keys(factorNames)) {
            let factor_scores = [] 
            
            for(let vp of payload.viewpointIds) {   
                for(let choice of  Object.keys(sorted_ranked_choices)) {
                    if(viewpointScores[vp].choiceScores[choice] != null) {
                        let choiceScores = viewpointScores[vp].choiceScores[choice].choiceFactorScores
                        let score = choiceScores[factor].score
                        let weight = choiceScores[factor].weight
                        //factor_scores.push(score * weight)
                        factor_scores.push(score)
                        raw_scores.push(score)
                        }
                    else {factor_scores.push(0)}  
                    }    
                
            }
             
            let factorName = factorNames[factor]
            //var series_dict = {'id': factor, 'name': factorName, 'data': factor_scores}
            var series_dict = {'id': factor, 'name': factorName, 'data': factor_scores}
            series_dicts.push(series_dict)
        }

        console.log("raw score:",raw_scores) 
        console.log("factorNamesfinal",factorNames)
        if(other_factor_scores.length > 0) {
            let other_factors_dict = {'id': 'na', 'name': "Other Factors", 'data': other_factor_scores}
            series_dicts.push(other_factors_dict)
        }
        console.log("series_dicts",series_dicts)
        let vp_dict = {
            data: {series: series_dicts},
            title: '',
            xaxis: {categories: viewpointNames}
            }
    
        
       
        return vp_dict
    }
    // End of Bar Charts Data for Compare Viewpoints Tab..............................................................







    @Action 
    async getFactorNames(payload:{factors: { [id: string]: any;}, keepIds?: any[]}) {
        var factorNames = {}
        for(var fId in payload.factors) {
            if(payload.keepIds != null) {
                if ((fId != 'M' ) && (payload.keepIds.includes(fId))) {
                factorNames[fId] = payload.factors[fId].name
                }
            }
        }
        return factorNames
    }

    @Action 
    async getViewpointNamesMap(payload:{viewpointIds:any[], viewpointmap}) {
        var viewpointNames = {}
        for (let i = 0; i < payload.viewpointIds.length; i++) {
            var vpID = payload.viewpointIds[i]
            for(let vpm of Object.keys(payload.viewpointmap)) {
                if(vpm === vpID) {
                    let name = payload.viewpointmap[vpm].name
                    viewpointNames[vpID] = name
                }
            }
        }
        console.log("returning vp names", viewpointNames)
      
        return viewpointNames
    }










    // ..........................................................................................
    // Begining of The Data Being Used In Compare Choice(s) Tab For Bar Chart:
    @Action
    async getStackedBarChartDataChoiceTab(payload: {decisionId: string, viewpointId: string, factorIds?: any[], factorParentId: string, choiceIdFilter?: any}) {
        // ONLY one viewpoint allowed. Many choices are shown as stacked bars of factor score composition
        let viewpointScores = this.viewpointScores[payload.viewpointId];
        let choices = getModule(Choices).choices;
        let choiceIds = getModule(Choices).choiceIds;
        let selectedChoices = getModule(WorkspaceOptions).choiceVisibility;
        var factors = getModule(Modelling).publishedModelFactorResources;
       
        
        let final_dict = {};
        let series_dicts = []
        var factorNames = {};
        let factorNames_as_groupNames = []
        if((payload.factorIds != null) || (payload.factorIds.length != Object.keys(factors).length)) {
            for(var fId in payload.factorIds) {
                factorNames[payload.factorIds[fId]] = factors[payload.factorIds[fId]].name;
                factorNames_as_groupNames.push(factorNames[payload.factorIds[fId]])

            }
        } else {
        var factorNames = await this.getFactorNames({factors:factors, keepIds: payload.factorIds});
        }
        
        // get choice names into one dict of {choiceId: "Choice name"}
        var choiceNames = {};
        var sorted_ranked_choices = {};      
        let rank_choices = {};
        for(let choice of choiceIds) {
            let choiceScores = viewpointScores.choiceScores[choice]
            if (choiceScores != null) {
                let rank = choiceScores.rank
                rank_choices[choice] = rank
                }
            }
        sorted_ranked_choices = _.mapValues(_.invert(_.invert(rank_choices)),parseInt);
        let allChoiceIds = []     
        for(var choiceId in choices) {  
            choiceNames[choiceId] = choices[choiceId].name;
            allChoiceIds.push(choices[choiceId].id)
        }
        
        console.log("ALL CHOICE NAMES Are:", choiceNames)  
        
        let choicesNonZero = []  //may want to filter out choices with 0 score
        for(let factor of Object.keys(factorNames)) {
            let factor_scores = [];
            for(let choice of  Object.keys(sorted_ranked_choices)) {
                if (viewpointScores.choiceScores[choice] != null) {
                    let choiceFactorScores = viewpointScores.choiceScores[choice].choiceFactorScores;
                    let score = choiceFactorScores[factor].score;


                    // The following 3 lines got changed as the charts were not showing the proper values if there was a weight
                    

                    // let weight = choiceFactorScores[factor].weight;
                    // factor_scores.push(score * weight);
                    // if(score*weight != 0) {choicesNonZero.push(choice) }



                    let weight = choiceFactorScores[factor];
                    if(selectedChoices[choice]){
                    factor_scores.push(score);}
                   
                    if(score != 0) {choicesNonZero.push(choice) } // need to see if all factors for the choice are 0
                }
                else {factor_scores.push(0)}  //?? valid way to handle missing scores?
            }  
              
            let factorName = factorNames[factor];
            let series_dict = {'id': factor, 'name': factorName, 'data': factor_scores};
            series_dicts.push(series_dict);
        }
       
        let category_of_choices =[]
        for (let i = 0; i< allChoiceIds.length; i++){
            if(selectedChoices[allChoiceIds[i]]){
                category_of_choices.push(choiceNames[allChoiceIds[i]])
                
            }
        }
        let vp_dict = {
            data: {series: series_dicts},
            title: {titles:[]},
            xaxis: {categories: category_of_choices}
            };
        
        Vue.set(final_dict, payload.viewpointId, vp_dict)
        for (let j = 0; j<payload.factorIds.length; j++){
            for (let i = 0; i< final_dict[payload.viewpointId].data.series.length; i++){
           
                if(final_dict[payload.viewpointId].data.series[i].id === payload.factorIds[j]){  //{viewpointid : {vp_dict}}
                    
                    vp_dict.title.titles[i] = (final_dict[payload.viewpointId].data.series[i].name)
                  
                 }
        
            }
        }
        
       console.log(final_dict)
        return final_dict    
}
    // End of The Data Being Used In Compare Choice(s) Tab for Bar Chart.................................



// Begining of Data Being Used in Compare Choices Tab for Radial/Donut Charts:
@Action
async getStackedRadialChartDataChoiceTab(payload: {scoreskeys: any, decisionId: string, viewpointId: string, factorIds?: any[], factorParentId: string, choiceIdFilter?: any}) {
        // ONLY one viewpoint allowed. Many choices are shown as stacked bars of factor score composition
        let viewpointScores = this.viewpointScores[payload.viewpointId];
        let choices = getModule(Choices).choices;
        let choiceIds = getModule(Choices).choiceIds;
        let selectedChoices = getModule(WorkspaceOptions).choiceVisibility;
        var factors = getModule(Modelling).publishedModelFactorResources;
       
        let number_of_classes = 0
        let final_dict = {};
        let series_dicts = []
        var factorNames = {};
        let factorNames_as_groupNames = []
        if((payload.factorIds != null) || (payload.factorIds.length != Object.keys(factors).length)) {
            for(var fId in payload.factorIds) {
                factorNames[payload.factorIds[fId]] = factors[payload.factorIds[fId]].name;
                factorNames_as_groupNames.push(factorNames[payload.factorIds[fId]])

            }
        } else {
        var factorNames = await this.getFactorNames({factors:factors, keepIds: payload.factorIds});
        }
        
        // get choice names into one dict of {choiceId: "Choice name"}
        var choiceNames = {};
        var sorted_ranked_choices = {};      
        let rank_choices = {};
        let category_of_choices =[]
        let choice_ID_name = {}
        let ids_of_choices = []
        let allChoiceIds = []     
        for(var choiceId in choices) {  
            choiceNames[choiceId] = choices[choiceId].name;
            allChoiceIds.push(choices[choiceId].id)
        }
        for (let choice_id = 0; choice_id< allChoiceIds.length; choice_id++){
            if(selectedChoices[allChoiceIds[choice_id]]){
                category_of_choices.push(choiceNames[allChoiceIds[choice_id]])
                ids_of_choices.push(allChoiceIds[choice_id]) 
                choice_ID_name [allChoiceIds[choice_id]] = choiceNames[allChoiceIds[choice_id]]  
                
            }
        }
        for(let choice of ids_of_choices) {
            let choiceScores = viewpointScores.choiceScores[choice]
            if (choiceScores != null) {
                let rank = choiceScores.rank
                rank_choices[choice] = rank
               
                
                }
            }
        let class_baundries = []  
        let name_of_classes = [] 
        let description_of_classes =[]
        sorted_ranked_choices = _.mapValues(_.invert(_.invert(rank_choices)),parseInt);
        let choicesNonZero = []  //may want to filter out choices with 0 score
        let all_factor_scores = {}
        let all_names_of_choices = {}
        let factor_scores_for_each_choice = []
        let the_choices_name = ''
        for(let choice of  Object.keys(sorted_ranked_choices)) {
            
            let factor_scores = [];
            for(let factor of Object.keys(factorNames)) {
                if (viewpointScores.choiceScores[choice] != null) {
                    
                    let choiceFactorScores = viewpointScores.choiceScores[choice].choiceFactorScores;
              
                    let score = choiceFactorScores[factor].score;
                   

                    number_of_classes = payload.scoreskeys[payload.viewpointId][factor]["scoringKeys"].length
                    for(let i = 0; i<number_of_classes; i++){
                        class_baundries.push (payload.scoreskeys[payload.viewpointId][factor]["scoringKeys"][i].upperLimit)
                        name_of_classes.push (payload.scoreskeys[payload.viewpointId][factor]["scoringKeys"][i].name)
                        } 

                    // scoreSelectedIds.push(payload.scoreskeys[vp][choiceScores[factor].id])
                    // The following 3 lines got changed as the charts were not showing the proper values if there was a weight
                    

                    // let weight = choiceFactorScores[factor].weight;
                    // factor_scores.push(score * weight);
                    // if(score*weight != 0) {choicesNonZero.push(choice) }



                    let weight = choiceFactorScores[factor];
                    // if(selectedChoices[choice]){
                    factor_scores.push(score);
                    // if(score != 0) {choicesNonZero.push(choice) } // need to see if all factors for the choice are 0
                }
                // else {factor_scores.push(0)}  //?? valid way to handle missing scores?
           
            let factorName = factorNames[factor];
            let series_dict = {'id': factor, 'name': factorName, 'data': factor_scores};
            series_dicts.push(series_dict);
            } 
           all_factor_scores[choice]= [factor_scores]  
           if (choice in choice_ID_name){
                the_choices_name = choice_ID_name[choice] 
                all_names_of_choices [choice] = the_choices_name
            } 
        }
        class_baundries = class_baundries.slice(0,number_of_classes)
        name_of_classes = name_of_classes.slice(0,number_of_classes)
        name_of_classes = name_of_classes.reverse()
        class_baundries = class_baundries.reverse()
        class_baundries.unshift(-1)
        console.log("name_of_classes", name_of_classes) 
        console.log("class_baundries", class_baundries)

        let scores_new = {}
        let num_of_factors = 0
        for (let choice of Object.keys(all_factor_scores)) {
            let new_factor_score = []
            num_of_factors = all_factor_scores[choice][0].length
            for(let i=0; i< num_of_factors; i++){
               for(let j=0; j<=number_of_classes;j++){
                    if (class_baundries[j]<all_factor_scores[choice][0][i] && all_factor_scores[choice][0][i]<=class_baundries[j+1]){
                        new_factor_score.push(j+1)
                    }
                }   
            }
            scores_new[choice] = [new_factor_score]   
        }
        let final_value  = {}
        let final_labels = []
        for(let choice of Object.keys(scores_new)){
            let translated_score = []
            for (let i = 1; i <= number_of_classes; i++){
                translated_score.push(Math.round((scores_new[choice][0].filter(x => x==i).length)*100/num_of_factors))
                final_labels.push(name_of_classes[i-1])     
         }
         final_value[choice] = [translated_score]
        } 
        let num_of_choices = 0 
        final_labels = final_labels.slice(0, number_of_classes)

        num_of_choices = Object.keys(final_value).length
        let radial_data = {}
        let radial = {}
        for (let i = 0; i< num_of_choices; i++){
            radial = {
                data: {series:Object.values(final_value)[i][0]},
                title: {text: "Choice Name: "+ Object.values(all_names_of_choices)[i]},
                labels: final_labels
            };
            radial_data[i] = radial
        }
        console.log("THE RADIAL", radial_data)
        return radial_data     
    }
// End of Data Being Used in Compare Choices Tab for Radial/Donut Charts.......................




// Begining of Data Being Used in Compare Choices Summary Charts:
@Action
async getStackedSummaryChartDataChoiceTab(payload: {scoreskeys: any, decisionId: string, viewpointId: string, factorIds?: any[], factorParentId: string, choiceIdFilter?: any}) {
        // ONLY one viewpoint allowed. Many choices are shown as stacked bars of factor score composition
        let viewpointScores = this.viewpointScores[payload.viewpointId];
        let choices = getModule(Choices).choices;
        let choiceIds = getModule(Choices).choiceIds;
        let selectedChoices = getModule(WorkspaceOptions).choiceVisibility;
        var factors = getModule(Modelling).publishedModelFactorResources;
        let using_factors = {}
        let number_of_classes = 0
        let final_dict = {};
        let series_dicts = []
        var factorNames = {};
        let factor_IDS = ''
        let children = []
        if((payload.factorIds != null) || (payload.factorIds.length != Object.keys(factors).length)) {
            for(var fId in payload.factorIds) {
               
                factorNames[payload.factorIds[fId]] = factors[payload.factorIds[fId]].name;
            
            }
        } else {
        var factorNames = await this.getFactorNames({factors:factors, keepIds: payload.factorIds});
        }
       
        // get choice names into one dict of {choiceId: "Choice name"}
        var choiceNames = {};
        var sorted_ranked_choices = {};      
        let rank_choices = {};
        let category_of_choices =[]
        let choice_ID_name = {}
        let ids_of_choices = []
        let allChoiceIds = []     
        for(var choiceId in choices) {  
            choiceNames[choiceId] = choices[choiceId].name;
            allChoiceIds.push(choices[choiceId].id)
        }
        for (let i = 0; i< allChoiceIds.length; i++){
            if(selectedChoices[allChoiceIds[i]]){
                category_of_choices.push(choiceNames[allChoiceIds[i]])
                ids_of_choices.push(allChoiceIds[i]) 
                choice_ID_name [allChoiceIds[i]] = choiceNames[allChoiceIds[i]]  
                
            }
        }
        for(let choice of ids_of_choices) {
            let choiceScores = viewpointScores.choiceScores[choice]
            if (choiceScores != null) {
                let rank = choiceScores.rank
                rank_choices[choice] = rank
               
                
                }
            }
        let class_baundries = []  
        let name_of_classes = [] 
        let description_of_classes =[]
        sorted_ranked_choices = _.mapValues(_.invert(_.invert(rank_choices)),parseInt);
        let choicesNonZero = []  //may want to filter out choices with 0 score
        let factor_scores_for_each_choice = []
        let the_choices_name = ''
        let factor_scores = [];
        console.log("THE ONLY FACTORS NAMESSSS", factorNames)
        for(let choice of  Object.keys(sorted_ranked_choices)) {
            for(let factor of Object.keys(factorNames)) {
                if (viewpointScores.choiceScores[choice] != null) {
                    let choiceFactorScores = viewpointScores.choiceScores[choice].choiceFactorScores;
                    let score = choiceFactorScores[factor].score;
                    number_of_classes = payload.scoreskeys[payload.viewpointId][factor]["scoringKeys"].length
                    for(let i = 0; i<number_of_classes; i++){
                        class_baundries.push (payload.scoreskeys[payload.viewpointId][factor]["scoringKeys"][i].upperLimit)
                        name_of_classes.push (payload.scoreskeys[payload.viewpointId][factor]["scoringKeys"][i].name)
                        }
                    factor_scores.push(score);
                    console.log("WHAT ARE THE FACTOR_SCORES>>>>>>>>>>>>>>>>>>>>>>>>>",factor_scores)
                    // if(score != 0) {choicesNonZero.push(choice) } // need to see if all factors for the choice are 0
                }
                // else {factor_scores.push(0)}  //?? valid way to handle missing scores?
            } 
        }
        console.log("WHAT ARE THE FACTOR_SCORES>>>>>>>>>>>>>>>>>>>>>>>>>",factor_scores)
        class_baundries = class_baundries.slice(0,number_of_classes)
        name_of_classes = name_of_classes.slice(0,number_of_classes)
        name_of_classes = name_of_classes.reverse()
        class_baundries = class_baundries.reverse()
        class_baundries.unshift(-1)
        console.log("name_of_classes", name_of_classes) 
        console.log("class_baundries", class_baundries)
        let new_factor_score = []
        for (let i = 0; i< factor_scores.length; i++) {
               for(let j=0; j<=number_of_classes;j++){
                    if (class_baundries[j]<factor_scores[i] && factor_scores[i]<=class_baundries[j+1]){
                        new_factor_score.push(j+1)
                    }
                }   
            }  
        console.log("WHAT ARE THE NEW FACTOR SCORES>>>>>>>>>>>>>>>>>>>>>>>>>",new_factor_score)
        let final_value  = []
        let final_labels = []

        for (let i = 1; i <= number_of_classes; i++)
        {
            final_value.push(Math.round((new_factor_score.filter(x => x==i).length)*100/new_factor_score.length))
            final_labels.push(name_of_classes[i-1])
        }

        console.log("WHAT ARE THE NEW FACTOR SCORES>>>>>>>>>>>>>>>>>>>>>>>>>",final_value)
        console.log("WHAT ARE THE NEW FACTOR SCORES>>>>>>>>>>>>>>>>>>>>>>>>>",final_labels)
        let radial_data = {}
        radial_data = {
            data: {series:final_value},
            title: {text: 'All Selected Choices Summary'},
            labels: final_labels
            };
        
        console.log("THE RADIAL", radial_data)
        return radial_data     
    }
// End of Data Being Used in Compare Choices Tab for Summary Charts.......................




    @Action
    async findRange(array) {
        array.sort()
        let max = array.at(-1)
        let min = array[0]
        var range = max - min 
        return range
    }
 
    
    @Action
    async getFactorImportanceChart(payload:{decisionId: String, viewpointIds?: any[], factorIds?: any[], viewpointId?: string}) {
        let viewpointScores = this.viewpointScores 
        // if viewpointIds == 1: create different chart 
        let factors = getModule(Modelling).publishedModelFactorResources
        // get all scores for each factor then calculate range of scores * weight
        var factorNames = await this.getFactorNames({factors:factors, keepIds: payload.factorIds})
        let viewpointmap = getModule(Viewpoints).decisionViewpointsMap
        console.log("viewpointIds", payload.viewpointIds)
        var viewpointNames = await this.getViewpointNamesMap({viewpointIds: payload.viewpointIds, viewpointmap: viewpointmap})
        // if multiple vps -> {series: [{data: [factor1imp, fact2imp], name: vp1}, {data: [factor1imp, fact2imp], name: "vp2"}]}
        let importances_dict_list = []
        for(let vp of payload.viewpointIds) {
            console.log("VP", vp)
            var importances_vp = {}
            var importances = []
            for(let factor of Object.keys(factorNames)) {
                let factor_scores = []
                var factor_weight = {}
                //console.log("Object.keys(viewpointScores)", Object.keys(viewpointScores[vp].choiceScores))
                for(let choice of  Object.keys(viewpointScores[vp].choiceScores)) {
                    if (viewpointScores[vp].choiceScores[choice] != null) {
                        let choiceFactorScores = viewpointScores[vp].choiceScores[choice].choiceFactorScores  
                        let score = choiceFactorScores[factor].score
                        factor_weight[factor] = choiceFactorScores[factor].weight  //repetitive
                        factor_scores.push(score)
                    }
                    else {factor_scores.push(0)}  //?? valid way to handle missing scores?
                    }
                var range = await this.findRange(factor_scores)
                let importance = range * factor_weight[factor] * 100
                importances.push(importance)
            }
            importances_vp[vp] = importances
            importances_dict_list.push({data: importances, name: viewpointNames[vp]})
        }
        if (payload.viewpointId != null) {
            // Sort the importances by selected vp
            var importances_list = []
            importances = importances_dict_list[0].data
            let factorNamesList: string[] = Object.values(factorNames)
            for(let factorName, i=0; i<factorNamesList.length; i++ ) {
                let importances_dict = {name: factorNamesList[i], importance:importances[i]}
                importances_list.push(importances_dict)
            }
            let sorted_importances = _.sortBy(importances_list, 'importance').reverse(); 
            var sorted_factorNames = []
            var sorted_importance_vals = []
            for(let i=0; i<sorted_importances.length; i++) {
                sorted_factorNames.push(sorted_importances[i].name)
                sorted_importance_vals.push(sorted_importances[i].importance)
            }
            let chart_dict = {series: [{data: sorted_importance_vals}],  //, name: viewpointNames[payload.viewpointId]}], //TODO
                              categories: sorted_factorNames,
                              type: 'bar',
                              title: 'Relative Factor Importance Across all Choices'}
            console.log('returning chart single vp', chart_dict)
            return chart_dict
        }
        else {let chart_dict = {series: importances_dict_list, 
                                categories: Object.values(factorNames),
                                title:  'Relative Factor Importance Across all Choices'}
        console.log("chart_dict ", chart_dict)
       
        return chart_dict
        }
    }
    /**
     * Recalculate all the group scores for a choice.
     * @param choiceId
     */
    @Action
    async calculateBarChartData(factorValues: string[], factorName) {
        var categoryCount = {}
        const unique = _.uniq(factorValues)
        // for(let category in factorValues) {
        //     categoryCount[category] += 1
        // }
        let count = 0
        for (let i = 0; i < factorValues.length; ++i) {
            if (categoryCount.hasOwnProperty(factorValues[i])) {
                categoryCount[factorValues[i]] = categoryCount[factorValues[i]] + 1
            } else {
                categoryCount[factorValues[i]] = 1
            }
            count++;
           }   
        let barChartData = {data: {
                                series: [{data:Object.values(categoryCount)}]
                                },
                                xaxis: {
                                    categories: Object.keys(categoryCount)
                                },
                                title:  {text: "Factor Value Counts"}
        }
        console.log("barCHartdata", barChartData)
        return barChartData
    }
    @Action
    async calculateHistogram(payload: {data: number[], factorName: string}) {
        let data = payload.data.filter(function( element ) {
            return element !== undefined;
         });
        var sortedData = data.sort();
        let numSigFigs = round(sortedData[sortedData.length -2],2).toString().length   //round to two decimals (most scores) 
        //then take the second to last data point and estimate number of significant digits it has then reduce it to 2 sig figs
        let SigFigFixer = numSigFigs - 2
        let multiplier = "1"
        for (i = 0; i < SigFigFixer; i++) {
            multiplier += "0";
        }
        var multiplierNum = parseInt(multiplier)
        let roundedFirstDataPoint = Math.round(sortedData[0] / multiplierNum ) * multiplierNum
        console.log("firstDataPoint", roundedFirstDataPoint)
        let numBins =  Math.round(Math.sqrt(data.length))  //should we round up? to not cut off edges?
        let binWidthRaw =  await this.findRange(data)/ numBins
        let binWidth = Math.round(binWidthRaw /multiplierNum) * multiplierNum
        var start = roundedFirstDataPoint
        if (roundedFirstDataPoint > data[0]) {
            //console.log("start is greater than first data point", roundedFirstDataPoint, data[0])
            var start = start - multiplierNum
        }
        var end = roundedFirstDataPoint + binWidth;
        var totalBinCountDict = {};
        var intervalDict = {}
        for(var i=0; i <= numBins; i++) {
            let binCount = 0 
            for(let dp of data) {
                if(i == numBins) {
                    if (dp >= start && dp <= end) {
                        binCount += 1
                    }} 
                else {if (dp >= start && dp < end) {
                    binCount += 1
                    }
                }
            }
            totalBinCountDict[i] = binCount
            intervalDict[i] = start + "-" + end
            start = end
            end = end + binWidth 
        }
        let barHeights: any[] = Object.values(totalBinCountDict)
        let xAxisLabels = Object.values(intervalDict)
        //data: {series: series_dicts},  series_dicts = [{name: "hi", data: [23,4,66,7]}]
        let histogramData = {data: {series: [{data:barHeights, name: payload.factorName}]}, 
                            title: {text: "Factor Value Distribution"},
                            xaxis: {categories: xAxisLabels},
                            binWidth: binWidth
                            }
        console.log("in Scoring.ts hist Data=", histogramData)
        return histogramData
    }

    @Action //factor tab
    async getHistogramFactorData(payload: {numeric:boolean, decisionId:string, viewpointId:string, viewpointIds:any[], factorId: string, 
        factorParentId: string, choiceId?:any[]}) {
        let viewpointScores = this.viewpointScores[payload.viewpointIds[0]]  
        //show factor data (numeric). only want one vp for this chart rn and one factorId. all choiceIds
        //if viewpointIds > 1: create different chart and combine all vp scores
        let factors = getModule(Modelling).publishedModelFactorResources
        let factorNames = await this.getFactorNames({factors:factors, keepIds: [payload.factorId]})
        let factorName = factorNames[payload.factorId]
        let choices = getModule(Choices).choices;
        var factorTypeDict = {}

        var factorValues = []
        for(let choiceId of Object.keys(choices)) {
            let factorVal = choices[choiceId][payload.factorId]
            factorValues.push(factorVal)
        }
        //check if data is numeric or categorical to determine chart type ie hist or bar for categorical data
        if(payload.numeric == true) {
            var histData = await this.calculateHistogram({data: factorValues, factorName: factorNames[payload.factorId]})
            return histData
        } else {
            var barChartData = await this.calculateBarChartData(factorValues, factorName)
      
            return barChartData
        }
        
    }

    @Action  //viewpoint tab!!
    async getHistogramScoreData(payload: {decisionId: string, viewpointId:string,  factorData:{}, factorId: string, viewpointIds?:any[], factorIds?:any[]}) {
        //display histogram of a factor's scores across all choices. one vp
        let viewpointScores = this.viewpointScores[payload.viewpointId]
        console.log("Inside getHistogramScoreData!! viewpointScores", viewpointScores)
        console.log('FACTOR ID', payload.factorId)
        let factors = getModule(Modelling).publishedModelFactorResources
        let factorNames = await this.getFactorNames({factors: factors, keepIds: [payload.factorId]})
        let factorName = factorNames[payload.factorId]
        let factorScores = [] 
        for(let choice of  Object.keys(viewpointScores.choiceScores)) {
            if (viewpointScores.choiceScores[choice] != null) {
                let choiceFactorScores = viewpointScores.choiceScores[choice].choiceFactorScores  
                let score = choiceFactorScores[payload.factorId].score
                let weight =choiceFactorScores[payload.factorId].weight  
                factorScores.push(score*weight*100)
            }
            else {factorScores.push(0)} 
            }
        console.log("factorScores!", factorScores)
        let chartData = this.calculateHistogram({data:factorScores, factorName: factorName})
        return chartData
        }

    @Action
    async getTwoFactorScoreScatterChart(payload: {decisionId: string, viewpointIds?:string[],  viewpointId:string, factorData: {}}) {
        console.log("inside scoring.ts factorIds", payload.factorData)  //['factor-0'].id , payload.factorData)
        let viewpointScores = this.viewpointScores[payload.viewpointId] //only want one vp (for now)
        console.log("INSIDE getTwoFactorScoreScatterChart viewpoint scores", viewpointScores)
        //display two factor's scores (numeric)        
        let factors = getModule(Modelling).publishedModelFactorResources
        console.log("factors", factors)
        var factorIds = [payload.factorData[0].id, payload.factorData[1].id]
        let factorNames = await this.getFactorNames({factors:factors, keepIds:factorIds})
        let choices = getModule(Choices).choices;
        var xyList = []
        //let factor1Data = factors[payload.factorIds[0]]
        console.log("factorNames", factorNames)
        // for(let i=0; i<2; i++) {
        let factor_scores0 = []
        let factor_scores1 = []
        for(let choice of  Object.keys(viewpointScores.choiceScores)) {
            //console.log("CHOICE", choice, "viewpointScores.choiceScores[choice]", viewpointScores.choiceScores[choice])
            if (viewpointScores.choiceScores[choice] != null) {
                let choiceFactorScores = viewpointScores.choiceScores[choice].choiceFactorScores  
                let score0 = choiceFactorScores[factorIds[0]].score
                let weight0 = choiceFactorScores[factorIds[0]].weight  
                factor_scores0.push(round(score0*weight0*100,3))
                let score1 = choiceFactorScores[factorIds[1]].score
                let weight1 = choiceFactorScores[factorIds[1]].weight  
                factor_scores1.push(round(score1*weight1*100),3)
                xyList.push([round(score0 * weight0 *100, 3), round(score1 * weight1 * 100, 3)])
            }
            }
        console.log("xyList", xyList)
        let viewpointNames = this.getViewpointNames({viewpointIds: [payload.viewpointId]})
        let chartData = {data: {
            series: [{data:xyList, name:factorNames[factorIds[1]]}],
            },
        title: {
            text: 'Factor Score Comparison for ' + viewpointNames[payload.viewpointId],
        },
        xaxis: {
            factorName: factorNames[factorIds[0]],
            tickAmount: 10
          },
        yaxis: {
            factorName: factorNames[factorIds[1]],
            tickAmount: 10
        }}
        console.log("chartdata", chartData)
        return chartData
    }

    @Action
    async recalculateScores(payload: { viewpointId: string, choiceId: string }) {
        await this.calculateGroups({viewpointId: payload.viewpointId, factorGroupId: 'M', choiceId: payload.choiceId});
    }

    /**
    
     * Recalculates the scores for the subtree
     *
     * @param payload Factor Group ID to calculate, Choice ID
     * @return Promise of all the choice factors for that group
     */
    @Action
    async calculateGroups(payload: { viewpointId: string, factorGroupId: string, choiceId: string }): Promise<ScoringData> {
        let viewpointChoiceScores = this.viewpointScores[payload.viewpointId].choiceScores[payload.choiceId];
        let viewpointFactorResources = getModule(Viewpoints).viewpointFactorResources[payload.viewpointId];
        let viewpointChoiceFactors = getModule(Viewpoints).viewpointChoiceFactorResource[payload.viewpointId][payload.choiceId] || {}
        let totalDots = getModule(Weighting).viewpointGroupDots[payload.viewpointId]['M'];
        let factorGroupId = payload.factorGroupId;
        let factorResources = getModule(Modelling).publishedModelFactorResources;
        let factorGroupResource = factorResources[factorGroupId] as FactorGroup;

        if (!viewpointChoiceScores || !factorGroupResource) {
            return {score: 0, scores: [], weight: 0};
        }

        let choiceFactorScores = viewpointChoiceScores.choiceFactorScores

        let children = (factorGroupResource.childrenIds || []).map(id => factorResources[id])

        let childrenScoringData: {[id: string]: ScoringData } = {};
        for (let child of children) {
            if (child.type === 'FACTOR') {
                childrenScoringData[child.id] = {
                    score: Scoring.getScore(choiceFactorScores[child.id], viewpointChoiceFactors[child.id]),
                    scores: Scoring.getScores(choiceFactorScores[child.id], viewpointChoiceFactors[child.id]),
                    weight: (Scoring.getWeight(child as Factor, viewpointFactorResources[child.id]) / totalDots)
                }
            } else {
                let childPayload = JSON.parse(JSON.stringify(payload))
                childPayload.factorGroupId = child.id;
                childrenScoringData[child.id] = await this.calculateGroups(childPayload)
            }
        }

        if (factorGroupResource.groupTypeDefinition && factorGroupResource.groupTypeDefinition.type === 'TABLE_FIXED') {
            // remove duplicates

            children.filter(c => (c as FactorGroup).groupTypeDefinition.type === 'TABLE_COLUMN')
                .forEach(f => {
                    delete childrenScoringData[f.id]
                })
        }

        let childrenScoringDataList = Object.values(childrenScoringData);
        let score: number;
        switch (factorGroupResource.id in viewpointFactorResources && childrenScoringDataList.length > 0 && viewpointFactorResources[factorGroupResource.id].summaryScoringFunction 
            ? viewpointFactorResources[factorGroupResource.id].summaryScoringFunction 
            : factorGroupResource.summaryScoringFunction
        ) {
            case 'WEIGHTED_SUM':
                let totalPossibleScore = childrenScoringDataList.map(s => s.weight)
                    .reduce((a, b) => a + b, 0);
                let summedScores = childrenScoringDataList
                    .map(s => Scoring.calculateFactorScore(s) * s.weight)
                    .reduce((a, b) => a + b, 0);
                if (totalPossibleScore) {
                    //console.log('summedScores', summedScores, 'totalPossibleScore', totalPossibleScore)
                    score = summedScores / totalPossibleScore;
                    //console.log("GROUP score", score)
                } else {
                    score = 0.0;
                }
                break;
            case 'MAX':
                score = childrenScoringDataList.map(s => Scoring.calculateFactorScore(s, 'MAX'))
                    .reduce(function (a, b) {
                        return Math.max(a, b);
                    });
                break;
            case 'MIN':
                score = childrenScoringDataList.map(s => Scoring.calculateFactorScore(s, "MIN"))
                    .reduce(function (a, b) {
                        return Math.min(a, b);
                    });
                break;
            default:
                    totalPossibleScore = childrenScoringDataList.map(s => s.weight)
                    .reduce((a, b) => a + b, 0);
                    summedScores = childrenScoringDataList
                    .map(s => Scoring.calculateFactorScore(s) * s.weight)
                    .reduce((a, b) => a + b, 0);
                if (totalPossibleScore) {
                    score = summedScores / totalPossibleScore;
                } else {
                    score = 0.0;
                }
                break;
        }


        score = Number(score.toFixed(6))
        this.setViewpointChoiceFactorScore({
            choiceId: payload.choiceId,
            viewpointId: payload.viewpointId,
            factorResourceId: factorGroupId,
            score: score
        })

        return {
            score: score,
            weight: getModule(Weighting).viewpointGroupDots[payload.viewpointId][factorGroupId] / totalDots
        }
    }

    private static getWeight(factor: Factor, viewpointFactorResource: ViewpointFactorResource) {
        if (viewpointFactorResource && viewpointFactorResource.numWeightingDots != undefined) {
            return viewpointFactorResource.numWeightingDots
        }
        return factor.numWeightingDots || 0
    }

    private static getScore(choiceScore: ChoiceFactorScore, viewpointChoiceScore: ViewpointChoiceFactor) {
        // Comment out viewpointChoiceScore and user Choice Score
        // if (viewpointChoiceScore && viewpointChoiceScore.score != undefined) {
        //     console.log(viewpointChoiceScore, choiceScore)
        //     return viewpointChoiceScore.score
        // }
        return choiceScore.score
    }

    private static getScores(choiceScore: ChoiceFactorScore, viewpointChoiceScore: ViewpointChoiceFactor) {
        // Comment out viewpointChoiceScore and user Choice Score
        // if (viewpointChoiceScore && viewpointChoiceScore.scores != undefined) {
        //     return viewpointChoiceScore.scores
        // }
        return choiceScore.scores
    }

    private static calculateFactorScore(choiceFactor: ScoringData, scoringType?: string) {
        if (choiceFactor.scores) {
            if(scoringType === 'MAX') {
                return choiceFactor.scores.reduce((a,b) => {return Math.max(a,b)})
            }
            if (scoringType === 'MIN') {
                return choiceFactor.scores.reduce((a, b) => { return Math.min(a, b) })
            }
            return choiceFactor.scores.reduce((a, b) => a + b, 0) / choiceFactor.scores.length
        }
        return choiceFactor.score;
    }

}

declare interface ScoringData {
    score: number,
    scores?: number[],
    weight: number
}

export declare interface ViewpointChoiceScore {
    viewpointId: string,
    modelId: string,
    revision: number,
    choiceScores: { [choiceId: string]: ChoiceScore }
}

export declare interface ChoiceScore {
    id: string,
    weight: number,
    score: number,
    rank: number,
    choiceFactorScores: { [id: string]: ChoiceFactorScore }
}

export declare interface ChoiceFactorScore {
    id: string,
    weight: number,
    numWeightingDots: number,
    score: number,
    scores: number[],
    factorContribution: number
}
